import { Component, OnInit, OnDestroy, HostBinding } from '@angular/core';
import { Subscription } from 'rxjs/Subscription';
import { RealTimeContextService } from '../../../real-time/real-time-context.service';
import { Mode, DistrictRealTimeZoom } from '../../../common/const';
import { MapContextService } from 'app/common/map-context.service';
import { environment } from 'environments/environment';

@Component({
  selector: 'informo-real-time-legend',
  templateUrl: './real-time-legend.component.html',
  styleUrls: ['./real-time-legend.component.scss']
})
export class RealTimeLegendComponent implements OnInit, OnDestroy {

  @HostBinding('class.closed') hideLegend = false;
  hasWaze: boolean = environment.options.sources.includes('waze');
  subscription: Subscription;
  districtLevel = true;
  mode: string;

  constructor(
    private realTimeContextService: RealTimeContextService,
    private mapContext: MapContextService
  ) { }

  ngOnInit() {
    this.subscription = this.realTimeContextService.mode$.subscribe((mode) => {
      this.mode = mode.mode;
    });
    this.mapContext.bboxChange.subscribe((e) => {
      // TODO QUITAR ESTE COMMENT
      // this.update(e.target.getZoom());
    });
  }

  toggleLegend() {
    if (this.realTimeContextService.getMode() !== Mode.UPCOMING) {
      this.hideLegend = !this.hideLegend;
    }
  }

  ngOnDestroy() {
    if (this.subscription) {
      this.subscription.unsubscribe();
    }
  }

  update(zoom) {
    if (zoom >= DistrictRealTimeZoom) {
      this.districtLevel = false;
    } else {
      this.districtLevel = true;
    }
  }
}



// WEBPACK FOOTER //
// ./src/app/cities/informo/real-time-legend/real-time-legend.component.ts